import { readable, writable, get } from 'svelte/store';

export const isAuthenticated = writable(false);
export const auth0Client = writable();
export const hostname = writable('');
export const username = writable();
export const email = writable();
export const userLocation = writable();
export const environment = writable();
export const version = writable();
export const site = writable();

const storedTheme = JSON.parse(localStorage.getItem("theme"));
export const theme = writable(storedTheme ? storedTheme : 'light');
theme.subscribe(value => {
    localStorage.setItem("theme", JSON.stringify(value));
});

const wantDebug = window.location.search.includes("debug=true");
export const showDebug = writable(wantDebug);
export const showDebugPane = writable(wantDebug);

const wantLocalBackend = window.location.href.includes("localhost:4280");
if (wantLocalBackend) {
    console.log("ADDING LOCAL BACKEND TO STACKS LIST");
}

const wantLegacy = window.location.search.includes("legacy=true");
export const showLegacy = writable(wantLegacy);

export const supportsWideCentershift = readable(true);

// The stack store is backed up by localStorage, which only stores strings.
// Therefore we have to parse the value when reading from the store
// and stringify when storing.
// We also export the set of available stack values as stacks.
//const temptest = {id: 1, name: "Temptest"};
//const iaas = {id: 2, name: "IaaS"};
//const cloudcttest = {id: 3, name: "CloudCTTest"};
//const cloudctiaas = {id: 4, name: "CloudCTIaaS"};
//const extproddtu = {id: 5, name: 'ExtprodDTU'};
export let stacks; // Upon first load, we don't have access to any stacks

// Currently known stack are: [temptest, iaas, cloudcttest, cloudctiaas, extproddtu, Meitner]

console.log('GETTING STORED STACK FROM LOCALSTORAGE');
const storedStack = JSON.parse(localStorage.getItem("stack"));
console.log('GOT STORED STACK FROM LOCALSTORAGE: ', storedStack);

export const stack = writable(storedStack);
console.log('STACK = ', get(stack));

// When the value of stack changes, store the value in localStorage
stack.subscribe(value => {
    if (!stacks || stacks.length == 0) return;
    // DEBUG: 
    console.log('UPDATING STACK WITH ', value);

    localStorage.setItem("stack", JSON.stringify(value));
    // DEBUG: console.log('CHECKED STORED STACK FROM LOCALSTORAGE: ', storedStack);
});

// Access info may contain a list of stacks. If so, the stacks list should only
// contain these stack elements
export const accessInfo = writable();
accessInfo.subscribe(info => {
    if (!info) return;
    if (!info.stacks || !Array.isArray(info.stacks) || info.stacks.length == 0) return;

    // First, clear the list of allowed stacks
    console.log('STACKS: ', stacks);
    stacks = [];

    if (wantLocalBackend) {
        stacks.push('localdev');
    }

    console.log('BUT ACCESS INFO STACKS: ', info.stacks);

    // Populate the list of allowed stacks with those from accessInfo
    info.stacks.forEach(s => stacks.push(s));
    console.log('STACKS: ', stacks);

    console.log('STACK: ', get(stack));

    // Once we have updated the list of stacks with allowed ones from the server,
    // check if the currently set is allowed. If not, default to the first one in the list.
    const currentStack = stacks.find(s => s == get(stack));
    console.log(':::::: CURRENT STACK = ', currentStack);
    if (!currentStack) {
        console.log(':::::: STACK =', get(stack), ' DID NOT MATCH ANY ALLOWED STACKS!');
        stack.set(stacks[0]);
    }

    // Check team info and set current team
    let allTeams = [];
    let defaultTeam;
    info.userservice_org_teams?.forEach(o => o.teams?.forEach(t => {
        allTeams.push(t);
        if (o.defaultTeam == t.id || t.name == 'default') {
            defaultTeam = t;
        }
    }));
    console.log(':::::: ACCESSINFO STORE SEES ALL TEAMS:', allTeams);
    console.log(`:::::: DEFAULT TEAM = ${defaultTeam?.name}-${defaultTeam?.id}`);

    let curTeam = get(currentTeam);
    console.log(`:::::: CHECKING CURRENT TEAM = ${currentTeam?.name}-${currentTeam?.id}`);
    if (!curTeam) {
        console.log(`:::::: SETTING CURRENT TEAM TO DEFAULT = ${defaultTeam?.name}-${defaultTeam?.id}`);
        currentTeam.set(defaultTeam);
    }

});
export const isAuthorised = writable(false);

export const currentSession = writable();
export const currentTomography = writable();

export const currentTeam = writable();

// Format of FDK recontructions. For now, may be limited to TIFF slices as individual files or as into ZIP archive, or as a BigTIFF-formatted stack.
const tiff_slices_individual = {id: "tiff_slices_individual", file_format: "tiff_slices", zip_binaries: false, label: "TIFF slices", description: "One (16-bit) TIFF file per slice"};
const bigtiff_stack = {id: "bigtiff_stack", file_format: "bigtiff_stack", zip_binaries: false, label: "BigTIFF stack", description: "All (16-bit) TIFF slices archived as BigTIFF"};
const tiff_slices_zip = {id: "tiff_slices_zip", file_format: "tiff_slices", zip_binaries: true, label: "ZIPped TIFF slices", description: "All (16-bit) TIFF slices archived as ZIP"};

export const outputFormats = [tiff_slices_individual, bigtiff_stack, tiff_slices_zip];

// Store the outputFormat persistently. We only need to store the id
const storedOutputFormatId = JSON.parse(localStorage.getItem("outputFormatId"));

// If we have a stored outputFormatId, use the corresponding format object. If none found, default to individial tiff slices
export const outputFormat = writable(storedOutputFormatId ? outputFormats.find(f => f.id == storedOutputFormatId) : tiff_slices_individual);

// When the outputFormat changes, store the id in localstorage
outputFormat.subscribe(value => {
    localStorage.setItem("outputFormatId", JSON.stringify(value?.id));
});
